import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import EmployeePage from './EmployeePage'
import HomePage from './HomePage'
import './App.css'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:slug" element={<EmployeePage />} />
      </Routes>
    </Router>
  )
}

export default App
